// tabelaNiveis.js

// Importação das imagens que guardou na pasta assets
import bronzeAdepto from './assets/niveis/bronze_adepto.png';
import prataAdepto from './assets/niveis/prata_adepto.png';
import ouroAdepto from './assets/niveis/ouro_adepto.png';
import diamanteAdepto from './assets/niveis/diamante_adepto.png';
import campeaoAdepto from './assets/niveis/campeao_adepto.png';

import bronzeJogador from './assets/niveis/bronze_jogador.png';
import prataJogador from './assets/niveis/prata_jogador.png';
import ouroJogador from './assets/niveis/ouro_jogador.png';
import diamanteJogador from './assets/niveis/diamante_jogador.png';
import campeaoJogador from './assets/niveis/campeao_jogador.png';

export const tabelaNiveis = [
  { nivel: 1, xpNecessario: 0 },
  { nivel: 2, xpNecessario: 100 },
  { nivel: 3, xpNecessario: 300 },
  { nivel: 4, xpNecessario: 700 },
  { nivel: 5, xpNecessario: 1500 },
  { nivel: 6, xpNecessario: 3000 },
  { nivel: 7, xpNecessario: 5000 },
  { nivel: 8, xpNecessario: 8000 },
  { nivel: 9, xpNecessario: 12000 },
  { nivel: 10, xpNecessario: 17000 },
  { nivel: 11, xpNecessario: 23000 },
  { nivel: 12, xpNecessario: 30000 },
  { nivel: 13, xpNecessario: 38000 },
  { nivel: 14, xpNecessario: 47000 },
  { nivel: 15, xpNecessario: 57000 },
  { nivel: 16, xpNecessario: 68000 },
  { nivel: 17, xpNecessario: 80000 },
  { nivel: 18, xpNecessario: 93000 },
  { nivel: 19, xpNecessario: 107000 },
  { nivel: 20, xpNecessario: 122000 },
  { nivel: 21, xpNecessario: 140000 },
  { nivel: 30, xpNecessario: 400000 },
  { nivel: 35, xpNecessario: 700000 },
  { nivel: 36, xpNecessario: 800000 },
  { nivel: 50, xpNecessario: 3000000 },
  { nivel: 51, xpNecessario: 3500000 },
  { nivel: 70, xpNecessario: 20000000 }
];

export function calcularNivel(xpAtual) {
  let nivelAtual = 1;
  for (let i = tabelaNiveis.length - 1; i >= 0; i--) {
    if (xpAtual >= tabelaNiveis[i].xpNecessario) {
      nivelAtual = tabelaNiveis[i].nivel;
      break;
    }
  }
  return nivelAtual;
}

// Nova função essencial para descobrir qual a imagem do escalão do Adepto
export function obterImagemAdepto(nivel) {
  if (nivel <= 10) return bronzeAdepto;
  if (nivel <= 20) return prataAdepto;
  if (nivel <= 35) return ouroAdepto;
  if (nivel <= 50) return diamanteAdepto;
  return campeaoAdepto;
}

// Nova função essencial para descobrir qual a imagem do escalão do Jogador
export function obterImagemJogador(nivel) {
  if (nivel <= 10) return bronzeJogador;
  if (nivel <= 20) return prataJogador;
  if (nivel <= 35) return ouroJogador;
  if (nivel <= 50) return diamanteJogador;
  return campeaoJogador;
}

// Função para dar pontos de XP a um utilizador no Firebase Firestore
export async function adicionarXP(uid, tipo, quantidadeBolas) {
  try {
    // Importações dinâmicas do Firebase para não estragar variáveis globais
    const { getFirestore, doc, updateDoc, increment } = await import('firebase/firestore');
    const db = getFirestore();
    
    // Identifica qual o campo correto com base no tipo (adepto ou jogador)
    const campoXP = tipo === 'adepto' ? 'xpAdepto' : 'xpJogador';
    
    // Cria a rota direta para o documento do utilizador
    const userRef = doc(db, "utilizadores", uid);
    
    // Executa o incremento atómico diretamente no servidor do Firebase
    await updateDoc(userRef, {
      [campoXP]: increment(quantidadeBolas)
    });
    
    console.log(`Sucesso: +${quantidadeBolas} XP de ${tipo} adicionados ao utilizador ${uid}`);
  } catch (error) {
    console.error("Erro ao adicionar pontos de XP no Firebase:", error.message);
  }
}
